import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionStatusPartialCorrectIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7333 0H4.26667C1.91025 0 0 1.91025 0 4.26667V11.7333C0 14.0897 1.91025 16 4.26667 16H11.7333C14.0897 16 16 14.0897 16 11.7333V4.26667C16 1.91025 14.0897 0 11.7333 0Z",
			fill: "#FAEFDD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8828 8.58105C13.7449 9.58798 13.3524 10.5431 12.7423 11.3558",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6201 3.02148C12.4229 3.6443 13.0537 4.46171 13.4524 5.39632",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.67554 2.1998C6.61667 1.8157 7.64027 1.6782 8.64941 1.80035",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.04778 3.52197C1.46707 5.60058 1.06003 9.3777 3.13863 11.9584C5.21725 14.5392 8.99437 14.9461 11.5751 12.8676",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.472 12.7139L4.20047 3.36621",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgQuestionStatusPartialCorrectIcon;
